export const statusFilter = Object.freeze({
  contacts: [],
  filter: "",
});
